/* eslint-disable no-extra-parens */
import { useEffect, useRef } from 'react';
import { IStoreState, WbStatePrivacyCookieKey } from '../interfaces/types';
import { gpcSignalCheckAction, gpcSignalStatusAction } from '../../../common/actions/statePrivacyActions';
import { UserProvider } from '../../../common/providers/userProvider';
import { getStatePrivacyPolicyCookie } from '../../../common/utilities/ccpaHelper';
import { setJsonCookie } from '../../../common/utilities/cookie';
import { reduxConnect } from '../../../common';

declare global {
    interface Navigator {
        globalPrivacyControl?: boolean;
    }
}

type GpcMonitorProps = {
    gpcSignalCheckAction: () => void;
    gpcSignalStatusAction: (isEnabled: boolean) => void;
    appInstanceId: string;
    pageId: string;
    currentLocationSlug: string;
    disableAds: boolean;
    dataPrivacyEnabled: boolean;
    sensitiveDataRestrictionEnabled: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { appInstanceId, pageId, user } = storeState?.appState?.appState || {};

    const { complianceRequirements } = storeState?.legal || {};
    const { dataPrivacyEnabled, sensitiveDataRestrictionEnabled, disableAds } = complianceRequirements || {};

    return {
        appInstanceId,
        pageId,
        currentLocationSlug: user?.ActiveLocation?.Locality?.SlugName,
        disableAds,
        dataPrivacyEnabled,
        sensitiveDataRestrictionEnabled
    };
};

const mapDispatchToProps = {
    gpcSignalCheckAction,
    gpcSignalStatusAction
};

export const GpcMonitor = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ 
    appInstanceId, 
    pageId, 
    currentLocationSlug, 
    gpcSignalCheckAction, 
    gpcSignalStatusAction,
    disableAds,
    dataPrivacyEnabled,
    sensitiveDataRestrictionEnabled }: GpcMonitorProps) => {
    const prevPropsRef = useRef<{
        pageId?: string;
        prevLocationSlug?: string;
    }>({});

    useEffect(() => {
        if (typeof disableAds === 'boolean' 
            && !disableAds
            && appInstanceId 
            && pageId 
            && currentLocationSlug 
            && ((pageId !== prevPropsRef.current.pageId) 
             || (currentLocationSlug !== prevPropsRef.current.prevLocationSlug))) {
            if (navigator.globalPrivacyControl && appInstanceId && (dataPrivacyEnabled || sensitiveDataRestrictionEnabled)) {
                (async()=> {
                    try {
                        await UserProvider.updateStatePrivacy(appInstanceId, true);
    
                        const statePrivacyCookie = getStatePrivacyPolicyCookie(WbStatePrivacyCookieKey);
    
                        if (statePrivacyCookie) {
                            setJsonCookie(WbStatePrivacyCookieKey, { ...statePrivacyCookie, doNotSell: true }, 10950);
                        } else {
                            setJsonCookie(WbStatePrivacyCookieKey, { doNotSell: true }, 10950);
                        }
    
                        gpcSignalStatusAction(true);

                        const gpcSignal = { doNotSell: true };
                        await UserProvider.saveGPCSignalToStorage(appInstanceId, gpcSignal);
                    } catch (error) {
                        console.error('WB: gpc signal error', error);
                    }
                })();
            }
            gpcSignalCheckAction();
            prevPropsRef.current = {
                pageId,
                prevLocationSlug: currentLocationSlug
            };
        }
    }, [pageId, currentLocationSlug, appInstanceId, disableAds, dataPrivacyEnabled, sensitiveDataRestrictionEnabled]);
    
    return null;
});